












import { ListDisplayMode } from "@/data/constants";
import { Component, Inject, Vue } from "vue-property-decorator";
@Component
export default class InboxPaginationControls extends Vue {
  // Inject
  @Inject({ from: "ticketsProvider" })
  public readonly $ticketsProvider!: () => any;
  @Inject({ from: "ticketsProviderMethods" })
  public readonly $ticketsMethods!: () => any;
  // Computed
  public get ticketsProvider() {
    return this.$ticketsProvider();
  }
  public get showPagination() {
    return this.ticketsProvider.total > this.ticketsProvider.limit;
  }
  public get isCompact() {
    const { displayMode } = this.$store.state.ui.support;
    return displayMode === ListDisplayMode.INBOX;
  }
}
